import React from 'react';
import { useDraggable, useDroppable } from '@dnd-kit/core';
import Img from 'react-cool-img';
import { Typography } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import { Container } from './styles';

const CardDND = ({
  id,
  data,
  factor,
  isDragging = false,
  status,
  onToggleStatus,
  onEditProduct,
}) => {
  const { setNodeRef, attributes, listeners, transform, transition } =
    useDraggable({ id });

  const { setNodeRef: setDroppableRef } = useDroppable({ id });

  const effectiveStatus = status || data?.status;
  const isCancelled = effectiveStatus === 'Cancelled';

  const stopDrag = e => {
    e.stopPropagation();
  };

  return (
    <Container
      ref={node => {
        setNodeRef(node);
        setDroppableRef(node);
      }}
      {...attributes}
      {...listeners}
      style={{
        transform: transform
          ? `translate3d(${transform.x}px, ${transform.y}px, 0)`
          : undefined,
        transition,
        cursor: 'grab',
        zIndex: isDragging ? 1000 : 'auto',
        position: isDragging ? 'absolute' : 'relative',
        pointerEvents: isDragging ? 'none' : 'auto',
        opacity: isCancelled ? 0.35 : 1,
      }}
    >
      <div
        style={{
          position: 'relative',
          width: 202 * factor,
          height: 340 * factor,
          margin: '1px 2px',
        }}
      >
        <Img
          style={{
            width: '100%',
            height: '100%',
            cursor: 'pointer',
            display: 'block',
          }}
          src={data.mainly_image}
          alt="a"
        />

        {onToggleStatus && (
          <button
            type="button"
            onPointerDown={stopDrag}
            onMouseDown={stopDrag}
            onTouchStart={stopDrag}
            onClick={e => {
              e.stopPropagation();
              onToggleStatus();
            }}
            style={{
              position: 'absolute',
              top: 8,
              left: 8,
              padding: '4px 10px',
              fontSize: 11,
              fontWeight: 600,
              letterSpacing: '0.05em',
              textTransform: 'uppercase',
              background: isCancelled ? '#fff' : 'rgba(0, 0, 0, 0.75)',
              color: isCancelled ? '#000' : '#fff',
              border: '1px solid #000',
              cursor: 'pointer',
              zIndex: 5,
            }}
          >
            {isCancelled ? 'Enable' : 'Disable'}
          </button>
        )}

        {onEditProduct && (
          <button
            type="button"
            onPointerDown={stopDrag}
            onMouseDown={stopDrag}
            onTouchStart={stopDrag}
            onClick={e => {
              e.stopPropagation();
              onEditProduct();
            }}
            title="Edit product info"
            style={{
              position: 'absolute',
              top: 8,
              right: 8,
              width: 28,
              height: 28,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: 'rgba(255, 255, 255, 0.9)',
              color: '#000',
              border: '1px solid #000',
              cursor: 'pointer',
              padding: 0,
              zIndex: 5,
            }}
          >
            <EditIcon style={{ fontSize: 16 }} />
          </button>
        )}

        <Typography
          align="center"
          style={{
            padding: factor < 0.5 ? '5px 0px' : '14px 12px',
            backgroundColor: 'rgba(0, 0, 0, 0.05)',
            color: 'white',
            width: '100%',
            fontSize:
              factor < 0.5 ? 10 : factor === 1 ? 22 : 18 * factor * 1.7,
            position: 'absolute',
            bottom: 0,
            left: 0,
            boxSizing: 'border-box',
          }}
        >
          {data?.style_code}
        </Typography>
      </div>
    </Container>
  );
};

export default CardDND;
